import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { DhContabilidadConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

const ImporteHaberFormGroup = ({
  vTipoCambio,
  vMoneda,
  iError,
  iTouched,
  fIsSubmitting,
  setFieldValue,
  handleChange,
  updateStore,
  rowIndex,
  tipoDocumentoValido,
  modalValido,
  mostrarModal,
  handleAgregarFila,
  esUltimaFila
}) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      const nuevoValor = e.target.value
      if (!nuevoValor) {
        setFieldValue('dh', '')
      } else {
        setFieldValue('dh', DhContabilidadConstant.HABER)
      }
      // const nuevoValorSecundario = vMoneda === 'SOLES' ? parseFloat(nuevoValor) / parseFloat(vTipoCambio) : parseFloat(nuevoValor) * parseFloat(vTipoCambio)
      // setFieldValue('importeHaberSecundario', (nuevoValorSecundario).toString())
      setFieldValue('importeDebe', '')

      setTimeout(() => {
        updateStore()
      }, 150)
    },
    [handleChange, setFieldValue, updateStore]
  )

  const onKeyDown = React.useCallback(
    e => {
      if (tipoDocumentoValido && !modalValido) {
        KeyEventUtil.functionOnEnterOrTab(mostrarModal, e)
      } else {
        if (esUltimaFila) {
          KeyEventUtil.functionOnEnterOrTab(handleAgregarFila, e)
        } else {
          KeyEventUtil.leaveOnEnterOrTab(`input-det-importeDebe-${rowIndex + 1}`, e)
        }
      }
    },
    [rowIndex, tipoDocumentoValido, modalValido, mostrarModal, handleAgregarFila, esUltimaFila]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='importeHaber'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id={`input-det-importeHaber-${rowIndex}`}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onChange={onChange}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteHaberFormGroup)
